
const aaa = [
    {
        path: "gongyingshangList",
        component: () => import("@/views/gongyingshang/gongyingshangList.vue"),
        meta:{title:'供应商'},
    },
]
export default aaa;